export default [
  {
    path: "/login/",
    component: () => import("@/pages/auth/login-page.vue"),
    meta: { title: "Login" },
  },
  {
    path: "/profil/",
    component: () => import("@/pages/pengguna/profil-page.vue"),
    meta: {
      title: "Profil",
      requiredLevel: ["admin", "superadmin", "admin_provinsi"],
    },
  },
  {
    path: "/profil/change-password",
    component: () => import("@/pages/pengguna/change-password.vue"),
    meta: {
      title: "Ganti Password",
      requiredLevel: ["admin", "superadmin", "admin_provinsi"],
    },
  },
  {
    path: "/pengguna/",
    component: () => import("@/pages/pengguna/pengguna-list.vue"),
    meta: {
      title: "Daftar Pengguna",
      requiredLevel: ["admin", "admin", "superadmin", "admin_provinsi"],
    },
  },
  {
    path: "/pengguna/create",
    component: () => import("@/pages/pengguna/pengguna-form.vue"),
    meta: {
      title: "Tambah Pengguna",
      requiredLevel: ["admin", "superadmin", "admin_provinsi"],
    },
  },
  {
    path: "/pengguna/edit/:id",
    component: () => import("@/pages/pengguna/pengguna-form.vue"),
    meta: {
      title: "Edit Pengguna",
      requiredLevel: ["admin", "superadmin", "admin_provinsi"],
    },
  },
];
